import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function usersReducer(state = initialState.users, action) {

    const mergeInUser = (users, userUpdate) => {
        const usersMinusStaleData = users.filter(user => user.id !== userUpdate.id);       
        return usersMinusStaleData.concat(userUpdate);
    }

    const deleteUser = (current, id) => {
        return current.filter(user => user.id !== id);
    } 

    switch (action.type) {
        case types.LOAD_USER_SUCCESS:
        case types.UPDATED_USER_SUCCESS:
            return mergeInUser(state, action.user);
        case types.DELETED_USER:      
            return deleteUser(state, action.id);      
        case types.DELETED_USER_INCOMING:  
        case types.UPDATED_USER_INCOMING://delete it so that when it is needed again it will need to reload
            return deleteUser(state, action.payload);           
        default:
            return state;
    }
}